import ProductContainer from 'checkout/containers/MiniCart/Product'

const List = (props) => {
  const { items = [], type = '' } = props.shipping || {}

  return (
    items.map((product) => (
      <ProductContainer key={product?.id} {...props} type={type} product={product} />
    ))
  )
}

export default List
